import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
import Switches from "vue-switches";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import EmployeeModule from "@/store/modules/employee.module";
import { toaster } from "@/utilities/toaster";
import Loader from "../../../components/widgets/loader.vue";
/**
 * Edit Employee Component
 */
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let EditEmployee = /** @class */ (() => {
    let EditEmployee = class EditEmployee extends Mixins(BaseMixer) {
        constructor() {
            // DATA
            super(...arguments);
            this.pageIsLoading = true;
            this.title = "Edit Employee";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Employees",
                    to: "/employees",
                },
                {
                    text: "Edit Employee",
                    active: true,
                },
            ];
            this.ctaButtons = [
                {
                    routeName: "Employees",
                },
            ];
        }
        //Computed
        get employees() {
            return EmployeeModule.employee;
        }
        updateEmployee() {
            this.validate("newUserObserver").then((response) => {
                if (response) {
                    EmployeeModule.UpdateEmployee(this.employees).then((response) => {
                        toaster.ShowSuccess("Employee was updated successfully.");
                        this.$router.push({ name: "Employees" });
                    });
                }
            });
        }
        get users() {
            return EmployeeModule.users;
        }
        get filteredUsers() {
            if (this.employees.reportingToUserName !== null) {
                const search = this.employees.reportingToUserName.toLowerCase();
                const matchedUsers = this.users.filter((user) => user.value.toLowerCase().includes(search));
                return matchedUsers;
            }
            else {
                return this.users;
            }
        }
        get designations() {
            return EmployeeModule.designations;
        }
        get filtereddesignations() {
            if (this.employees.designation !== null) {
                const search = this.employees.designation.toLowerCase();
                const matcheddesignations = this.designations.filter((designation) => designation.designationName.toLowerCase().includes(search));
                return matcheddesignations;
            }
            else {
                return this.designations;
            }
        }
        handleUserInput() {
            const selectedUser = this.filteredUsers.find((user) => user.value.trim().toLowerCase() === this.employees.reportingToUserName.trim().toLowerCase());
            if (selectedUser) {
                this.employees.reportingTo = selectedUser.id.toString();
            }
            else {
                this.employees.reportingTo = null;
            }
        }
        handleDesignationInput() {
            const selectedDesignation = this.filtereddesignations.find((designation) => designation.designationName.trim().toLowerCase() === this.employees.designation.trim().toLowerCase());
            if (selectedDesignation) {
                this.employees.designationId = selectedDesignation.id.toString();
            }
            else {
                this.employees.designationId = null;
            }
        }
        //Lifecycle
        created() {
            var employeeId = parseInt(this.$route.params.employeeId);
            EmployeeModule.GetEmployeeDetailById(employeeId).then((response) => {
                this.pageIsLoading = false;
            });
        }
    };
    EditEmployee = __decorate([
        Component({
            name: "EditEmployee",
            components: {
                Layout,
                PageHeader,
                Switches,
                Loader,
            },
        })
    ], EditEmployee);
    return EditEmployee;
})();
export default EditEmployee;
